<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';
  //reset
  input[type=text]:focus {
    outline: none;
    border: 1px color('black') solid;
  }

  .textfield{
    transition: all 0.3s ease-out;
    width: 100%;
    background-color: white;
    border: 1px color('grey', 'dark') solid;
    padding: 0.4em;
    border-radius: 0.2em;
    color: color("black");
    // line-height: 0;
    font-family: $firaSans;
    font-size: font-size("default"); //min 16px to avoid zoom in ios
    @include respond-at("x-large"){
      font-size: font-size("deka");
    }
    &::placeholder {
      // line-height: normal;
      color: color('grey', 'dark');
    }
    &.\--headline {
      font-size: font-size("mega");
      color: color("flamingo");
      font-weight: 500;
    }
  }
</style>
<template>
  <input
        class="textfield"
        :type="type"
        :name="name"
        :value="value"
        :class="cssClass"
        @keyup="callback($event)"
        >
</template>
<script>
// imports
export default {
  // child components this component calls
  components: { },
  // scoped variables in this component
  data () {
    return { };
  },
  // observed variables (by function)
  computed: { },
  // global mixins used like methods
  mixins: [],
  // functions firing by template
  methods: {
    callback: function(e) {
      this.$emit('click', e);
    }
  },
  // variables passed from parent template
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    cssClass: {
      type: String,
      default: ''
    }
  },
  // Lifecycle hooks
  created () { },
  mounted () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy() { },
  destroyed () { }
};
</script>



// WEBPACK FOOTER //
// src/components/textfield.vue